import { useState } from 'react';

import { unknownLabel } from '../../../common/const/commonConst';

/**
 * 更新日時の状態管理用カスタムフック
 */
export const useStateUpdatedDatetime = () => {
	const [lastUpdatedDatetime, setLastUpdatedDatetime] = useState<string | undefined>(unknownLabel); // 更新日時の管理

	return {
		lastUpdatedDatetime,
		setLastUpdatedDatetime,
	};
};
